import Phaser from "phaser";
import { validateContent } from "@gunnrats23/shared";
import { LabScene } from "./game/LabScene";
import { AppController } from "./ui/AppController";
import "./styles.css";

const errors = validateContent();
if (errors.length > 0) {
  throw new Error(errors.join("\n"));
}

const labScene = new LabScene();

new Phaser.Game({
  type: Phaser.AUTO,
  parent: "game-canvas",
  width: window.innerWidth,
  height: window.innerHeight,
  backgroundColor: "#07151b",
  scene: [labScene],
  scale: {
    mode: Phaser.Scale.RESIZE,
    parent: "game-canvas",
    width: "100%",
    height: "100%"
  },
  render: {
    pixelArt: true,
    antialias: false
  }
});

const uiRoot = document.querySelector<HTMLElement>("#game-ui");
if (!uiRoot) {
  throw new Error("Missing #game-ui root.");
}

new AppController(uiRoot, labScene);
